import React, { PureComponent } from "react";
import { injectIntl, defineMessages } from "react-intl";

import { Icon, Button } from "semantic-ui-react";
import Tooltip from "material-ui/Tooltip";
import { EduTemplateVideo, EduTemplateAddEdit, EduTemplateDelete } from "components";

import classNames from "classnames/bind";
import styles from "./EduTemplateInTableMenu.css";
const cx = classNames.bind(styles);

class EduTemplateInTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false,
      videoModal: false,
    };
  }

  toggleDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  toggleVideoModal = () => {
    this.setState({ videoModal: !this.state.videoModal });
  };

  toggleEditModal = (e) => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal, videoModal, editModal } = this.state;
    const { isAuth, dataInfo } = this.props;
    const { toggleDeleteModal, toggleVideoModal, toggleEditModal } = this;

    // isAuth : 1-사용자, 2-관리자
    // isSaas : 0-구축형, 1-서비스형
    // isPublic : 0-사용자, 1-기본
    return (
      <div className={"inline-conf-area"}>
        {/* 영상 보기 */}
        <Tooltip title={defineMessages(formatMessage({ id: "EduTemplate_3", defaultMessage: "영상 보기" }))} placement="bottom">
          <Icon color="grey" className={cx("icon-copy")} name="video play" link onClick={toggleVideoModal} />
        </Tooltip>
        {videoModal && <EduTemplateVideo isAuth={isAuth} dataInfo={dataInfo} toggleModal={toggleVideoModal} />}

        {/* 교육 템플릿 수정 */}
        {/* {isAuth === 2 && (
          <Tooltip title={defineMessages(formatMessage({ id: "ExamTemplateInTableMenu_3", defaultMessage: "템플릿 수정" }))} placement="bottom">
            <Icon color="grey" className={cx("icon-edit")} name="edit" link onClick={toggleEditModal} />
          </Tooltip>
        )}
        {editModal && <EduTemplateAddEdit isAuth={isAuth} config={{ mode: "edit", dataInfo }} toggleModal={toggleEditModal} />} */}

        {/* 교육 템플릿 삭제 */}
        {isAuth === 2 && (
          <Tooltip title={defineMessages(formatMessage({ id: "ExamTemplateInTableMenu_4", defaultMessage: "템플릿 삭제" }))} placement="bottom">
            <Icon color="grey" className={cx("icon-remove")} name="remove circle" link onClick={toggleDeleteModal} />
          </Tooltip>
        )}
        {deleteModal && <EduTemplateDelete isAuth={isAuth} dataInfo={dataInfo} toggleModal={toggleDeleteModal} />}
      </div>
    );
  }
}

export default injectIntl(EduTemplateInTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/EduTemplateInTableMenu.js